import { cn } from '@/shared/utils/cn'
import { statusLabel, statusTone } from './documentUtils'

interface Props {
  status: string | null | undefined
  className?: string
}

/**
 * Tiny pill badge used in the documents list. Tones map to the same palette
 * used by the chat composer: emerald for success, amber for warning, rose for
 * danger, neutral muted for unknown/processing-without-status.
 */
export function DocumentStatusBadge({ status, className }: Props) {
  const tone = statusTone(status)
  return (
    <span className={cn('doc-status-badge', `tone-${tone}`, className)}>
      <span className="doc-status-dot" aria-hidden="true" />
      {statusLabel(status)}
    </span>
  )
}
